import { createSelector } from 'redux-orm';
import orm from './ormReducer';
import {selectActiveCircle, selectActiveUser} from '../../features/dashboard/dashboardSlice';
import {selectUserInfo} from '../../features/login/loginSlice';

export const ORMUsers = createSelector(orm.Users);
export const ORMCircles = createSelector(orm.Circles);
export const ORMLocations = createSelector(orm.Locations);
export const ORMPending = createSelector(orm.PendingUsers);


// =====GEOINFO BY ID=====
export const locationByID = state => id => ORMLocations(state, id) || {};

// =====USERS BY ID=====
export const usersByID = state => id => ORMUsers(state, id);

// =====CIRCLES BY ID=====
export const circlesByID = state => id => ORMCircles(state, id);

// =====PENDING BY ID=====
export const pendingByID = state => id => ORMPending(state, id);

//=====IS USER AN ACCOUNT OWNER=====
export const isOwner = id => createSelector(
    [orm, id],
    (session) => {

    }
);


// =====ALL USERS IDS=====
export const allUsersIDs = createSelector(
    [orm],
    (session) => {
        const circles = session.Circles.all().toModelArray();

        const allIDs = circles.flatMap((circle) => circle.members);
        const uniqueIDs = new Set(allIDs);

        return Array.from(uniqueIDs);
    }
);

// =====SELECTED USER ON MAP=====
export const currentUserInfo = createSelector(
    [orm, selectActiveUser],

    (session, currentUser) => {

        if (currentUser === undefined || currentUser === null) return [];

        const usersModels = session.Users.all().toModelArray();

        return usersModels.flatMap((user) => {

            if (user._fields.id === currentUser) {
                return   {
                    ...user._fields,
                };
            } else {
                return [];
            }
        })[0];
    }
);


// =====SELECTED CURRENT CIRCLE USERS=====

export const currentCircleUsers = createSelector(
    [orm, selectActiveCircle],

    (session, currentCircle) => {

        const circlesModels = session.Circles.all().toModelArray();

        return circlesModels.flatMap((circle) => {

            if (circle.id === currentCircle) {

                if (circle.members) {
                    return circle.members
                }

                return null;

            } return [];
        });
    }
);

// =====SELECTED CURRENT CIRCLE DEVICES=====

export const currentCircleDevices = createSelector(
    [orm, selectActiveCircle],

    (session, currentCircle) => {

        const circlesModels = session.Circles.all().toModelArray();

        return circlesModels.flatMap((circle) => {

            if (circle.id === currentCircle) {

                if (circle.devices) {
                    return circle.devices
                }

                return null;

            } return [];
        });
    }
);

// =====SELECTED CURRENT CIRCLE DEVICES & USERS=====

export const currentCircleUsersAll = createSelector(
    [orm, selectActiveCircle],

    (session, currentCircle) => {

        const circlesModels = session.Circles.all().toModelArray();

        return circlesModels.flatMap((circle) => {

            if (circle.id === currentCircle) {

                return circle.devices.concat(circle.members);

            }  return [];
        });
    }
);

// =====SELECTED CURRENT USER LOCATION INFO=====

export const currentUserLocation = createSelector(
    [orm, selectActiveUser],

    (session, currentUser) => {

        if (currentUser === undefined || currentUser === null) return [];

        const locationsModels = session.Locations.all().toModelArray();

        return locationsModels.flatMap((user) => {

            if (user.id === currentUser) {

                if (user.location) {
                    return [
                        {
                            lat: user.location.latitude,
                            lng: user.location.longitude
                        }
                    ];
                }

                return null;

            } else {
                return [];
            }
        });
    }
);

